// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11LVW","newExpiryDate":"styles_newExpiryDate__155RP","footer":"styles_footer__3R5rW"};